import { render, staticRenderFns } from "./SecondaryIconButton.vue?vue&type=template&id=59ba73e4&scoped=true&"
import script from "./SecondaryIconButton.vue?vue&type=script&lang=ts&"
export * from "./SecondaryIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./SecondaryIconButton.vue?vue&type=style&index=0&id=59ba73e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ba73e4",
  null
  
)

export default component.exports